/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { VivaLiteScanStrictHttpResponse } from '../../viva-lite-scan-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SystemIdentifierAccessCodeModel } from '../../models/system-identifier-access-code-model';

export interface AdminSystemIdentifierAccessSaveIdPost$Params {
  id: string;
  
    /**
     * The system identifier access code model to save
     */
    body?: SystemIdentifierAccessCodeModel
}

export function adminSystemIdentifierAccessSaveIdPost(http: HttpClient, rootUrl: string, params: AdminSystemIdentifierAccessSaveIdPost$Params, context?: HttpContext): Observable<VivaLiteScanStrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, adminSystemIdentifierAccessSaveIdPost.PATH, 'post');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as VivaLiteScanStrictHttpResponse<string>;
    })
  );
}

adminSystemIdentifierAccessSaveIdPost.PATH = '/Admin/SystemIdentifierAccessSave/{id}';
